import type { EscapeRoomAttempt } from '@/domain/escapeRoom'
import type { EscapeRoomAttemptRepository } from '@/repositories/EscapeRoomAttemptRepository'

const STORAGE_KEY = 'cybertales.escapeRoomAttempts'

function readAll(): EscapeRoomAttempt[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as EscapeRoomAttempt[]) : []
  } catch {
    return []
  }
}

function writeAll(items: EscapeRoomAttempt[]) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  } catch {
    // best-effort — escape room attempts simply won't persist across reloads.
  }
}

export class LocalEscapeRoomAttemptRepository implements EscapeRoomAttemptRepository {
  async getActiveAttempt(userId: string, roomId: string): Promise<EscapeRoomAttempt | null> {
    return (
      readAll()
        .filter((a) => a.userId === userId && a.roomId === roomId && a.status === 'in_progress')
        .sort((a, b) => b.startedAt.localeCompare(a.startedAt))[0] ?? null
    )
  }

  async listAttempts(userId: string, roomId: string): Promise<EscapeRoomAttempt[]> {
    return readAll().filter((a) => a.userId === userId && a.roomId === roomId)
  }

  async startAttempt(attempt: EscapeRoomAttempt): Promise<void> {
    const all = readAll()
    all.push(attempt)
    writeAll(all)
  }

  async saveAttempt(attempt: EscapeRoomAttempt): Promise<void> {
    const all = readAll()
    const idx = all.findIndex((a) => a.id === attempt.id)
    if (idx >= 0) all[idx] = attempt
    else all.push(attempt)
    writeAll(all)
  }
}
